import { formatEquineAge } from './equineAge';

const capitalize = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

/**
 * Construit le subtitle d'une carte cheval :
 *   "X ans · Type · Sexe · Localisation"
 *
 * Champs manquants skippés silencieusement (.filter(Boolean)).
 * Retourne null si tout est vide → permet à l'appelant de masquer la ligne.
 *
 * Séparateur : · (middle dot U+00B7), aligné sur le mobile.
 *
 * @param {object} horse
 * @returns {string|null}
 */
export function buildHorseSubtitle(horse) {
  if (!horse) return null;
  const parts = [
    formatEquineAge(horse.dateOfBirth),
    capitalize(horse.type),
    capitalize(horse.sex),
    horse.location?.city,
  ].filter(Boolean);
  return parts.length > 0 ? parts.join(' · ') : null;
}
